<template>
  <div>
    <div class="feedback" v-if="feedback" v-translate>
      The document is not an accepted format.  Please attach a PDF, JPEG, PNG, or Word file.
    </div>

    <div @click="onClickContainer" :class="styles">
      <input type="file" accept= "application/pdf,text/csv,text/plain,image/jpeg,image/jpg,image/png,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document" hidden ref="file" @change="onSelectFile($event)" />


      <div class="upload_wrapper" v-if="!filename">
        <div class="upload">
          <span v-translate class="text-caps">Upload</span>
        </div>
        <div class="upload-feedback">
          <span v-translate class="text-caps" v-html="fileUploadStatus">{{fileUploadStatus}}</span>
        </div>
      </div>

      <div v-else-if="!feedback" class="container">
        <div class="file-upload-name-wrapper">
          <a class="text" :href="file" download target="_blank">
            <md-icon class="text">download</md-icon>
            <span class="text">
              {{ filename }}
            </span>
          </a>
          <div class="reset" @click="resetFile">
            <md-icon>close</md-icon>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'FilePicker',
  props: {
    filename: {
      /*
       * If this prop is passed in, display this name like it's a loaded file
       */
      type: String,
      default: '',
    },
    file: {
      /*
       * If this prop is passed in, display this name like it's a loaded file
       */
      type: String,
      default: '',
    },
    readAsString: {
      /*
       * If true, will read file as string
       * If false, will pass back original file
       */
      type: Boolean,
      default: true,
    },
    styles: {
      type: String,
      default: 'primary',
    },
    documents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fileUploadStatus: this.$gettext("No document uploaded"),
      feedback: false,
      reader: new FileReader(),
    }
  },

  created() {
    this.onFileLoaded = this.onFileLoaded.bind(this)
    if (this.documents.length) {
      this.fileUploadStatus = this.$gettext("Upload successful")
    }
  },
  methods: {
    onClickContainer() {
      this.feedback = false
      // Don't allow user to add a file if there is already a file here
      if (!this.filename) {
        this.$refs.file.click()
      }
    },
    onSelectFile(event) {
      if ([undefined, null].includes(event.target.files[0])) { return }

      const file = event.target.files[0]
      this.fileUploadStatus = this.$gettext("No document uploaded")

      const defaultAllowedFileTypes = [
        "text/csv",
        "text/plain",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
      ]

      if (!defaultAllowedFileTypes.includes(file.type)) {
        return this.feedback = true
      }

      this.reader.onloadend = this.onFileLoaded(file)
      this.reader.readAsText(file)
      this.fileUploadStatus = this.$gettext("Upload successful")
    },
    onFileLoaded(file) {
      if (this.readAsString) {
        this.$emit('loaded', this.reader.result)
      } else {
        this.$emit('loaded', file)
      }
    },
    resetFile() {
      this.$refs.file.value = null
      this.$emit('reset')
    },
  },
  watch: {
    documents: function () {
      if (this.documents.length === 0) {
        this.fileUploadStatus = this.$gettext("No document uploaded")
      }

      if (this.documents.length) {
        this.fileUploadStatus = this.$gettext("Upload successful")
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.primary {
  width: 100%;
  display: flex;
  height: 3rem;
  align-items: center;
  cursor: pointer;


  &:hover {
    background-color: $soft-gray;
  }
}

.secondary {
  min-width: 88px;
  max-width: 100%;
  height: 36px;
  border-radius: 2px;
  font-size: 14px;
  text-transform: uppercase;
  background-color: #3775dd;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;

  span {
    color: white;
    font-weight: 600;
    font-family: $base-content-font-family;
  }
}

.container {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.text {
  color: $base-gray;
  font-size: 0.8rem;
  padding: 0.5rem;
}
.text-caps {
  color: $base-gray;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.file-upload-name-wrapper {
  display: flex;
  width: 100%;
  height: 3rem;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #EBEBEB;
  border-bottom-color: #CCCCCC;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.reset {
  // Making the X button a little bigger for easier clicking
  padding: 0.5rem;
}
.feedback {
  color: $ruby;
}
.upload_wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: var(--light-brand-color);
}
.upload {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 100%;
  background-color: #CCCCCC;
  border-width: 1px;
  border-color: var(--light-brand-color);
  border-style: solid;
  border-right-width: 0px;
}

.upload-feedback {
  background-color: white;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-color: var(--light-brand-color);
  border-style: solid;
}
</style>
